// Text formatting utilities
export const camelCaseToTitle = (str) => {
  return str
    .replace(/([A-Z])/g, ' $1') // Add space before capital letters
    .replace(/^./, (str) => str.toUpperCase()) // Capitalize first letter
    .trim();
};

// Convert text to proper title case
export const toTitleCase = (str) => {
  return str.replace(/\w\S*/g, (txt) =>
    txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
  );
};

// Format category names consistently
export const formatCategoryName = (category) => {
  if (!category) return '';
  
  // Handle common abbreviations
  const abbreviations = {
    'iv': 'IV',
    'icu': 'ICU',
    'er': 'ER',
    'or': 'OR',
    'mri': 'MRI',
    'ct': 'CT',
    'ecg': 'ECG',
    'ekg': 'EKG',
    'ultrasound': 'Ultrasound',
    'xray': 'X-Ray',
    'x-ray': 'X-Ray',
  };

  let formatted = category
    .replace(/([a-z])([A-Z])/g, '$1 $2') // Add space between camelCase
    .replace(/[_-]/g, ' ') // Replace underscores and hyphens with spaces
    .toLowerCase()
    .split(' ')
    .map(word => {
      // Check if word is a common abbreviation
      if (abbreviations[word.toLowerCase()]) {
        return abbreviations[word.toLowerCase()];
      }
      // Capitalize first letter of each word
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(' ');

  return formatted;
};

// Format product names for display
export const formatProductName = (name) => {
  if (!name) return '';
  
  return name
    .replace(/([a-z])([A-Z])/g, '$1 $2') // Add space between camelCase
    .replace(/[_-]/g, ' ') // Replace underscores and hyphens with spaces
    .replace(/\b\w/g, char => char.toUpperCase()) // Capitalize each word
    .trim();
};

// Number formatting utilities
export const formatNumber = (num, locale = 'en') => {
  if (isNaN(num)) return num;
  
  const options = {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  };
  
  if (locale === 'ar') {
    return new Intl.NumberFormat('ar-EG', options).format(num);
  }
  
  return new Intl.NumberFormat('en-US', options).format(num);
};

// Date formatting for RTL/LTR
export const formatDate = (date, locale = 'en') => {
  const dateObj = new Date(date);
  
  if (locale === 'ar') {
    return new Intl.DateTimeFormat('ar-EG', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    }).format(dateObj);
  }
  
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }).format(dateObj);
};